import React, { useState, useEffect } from 'react'
import { Link, useLocation, Redirect } from 'react-router-dom'

import { Form, Input, Button } from './../../components/Form'
import { mensagemErro, mensagemSucesso } from './../../components/Layout'
import api from './../../api'

import { useAuth } from './../../context/Auth'
import { useLayout } from './../../context/Layout'
import { useTheme } from './../../context/Theme'

import ReCAPTCHA from "react-google-recaptcha";
import './style.scss'

function CadastroCodigo() {

    const [load, setLoad] = useState(false)
    const [loadResend, setLoadResend] = useState(false)
    const [logado, setLogado] = useState(false)
    const [validacao, setValidacao] = useState('')

    const location = useLocation()
    const { setUser } = useAuth()
    const { isScreenLogin } = useLayout()
    const { theme } = useTheme()

    const recaptchaRef = React.createRef();

    useEffect(() => {
        isScreenLogin(true)
        return () => isScreenLogin(false)
    }, [isScreenLogin])

    async function onFinishCadastro(data) {

        if (!data.codigo) {
            mensagemErro('Digite o código de verificação!')
            return
        }

        recaptchaRef.current.execute()

        setLoad(true)

        try {

            const resp = await api.post('login/codigo', {
                email: location.state.email,
                codigo: data.codigo
            })

            if (resp.data.type === 0) {

                const { id, nome, email, token, avatar } = resp.data.value

                /** Adicona o token para futuras requisições */
                api.defaults.headers.Authorization = `Bearer ${token}`

                /** Coloca o usuário logado em Contexto */
                setUser({
                    id,
                    refresh: id,
                    nome,
                    email,
                    avatar,
                    token
                })

                mensagemSucesso('Seja bem vindo ao Ambientar, te enviamos um e-mail com a sua nova senha!')

                setLoad(false)
                setLogado(true)
            }
            else if (resp.data.type === 1) {
                setValidacao(resp.data.mensagem)
            }

            setLoad(false)

        } catch (error) {

            setLoad(false)
            mensagemErro('Ops, parece que não foi possível recuperar este cadastro. Tente novamente mais tarde!')
            console.log(error);
        }
    }

    const [timer, setTimer] = useState(0)

    useEffect(() => {
        let interval = null
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(timer - 1)
            }, 1000)
        } else {
            clearInterval(interval)
        }
        return () => clearInterval(interval)
    }, [timer])

    async function reenviarCodigo() {
        setLoadResend(true)
        try {
            await api.post('login/solicitaNovoCodigo', {
                email: location.state.email
            })

            mensagemSucesso('Código reenviado com sucesso!')
            setTimer(30)
        } catch (error) {
            mensagemErro('Erro ao reenviar código. Tente novamente.')
        }
        setLoadResend(false)
    }

    if (logado) return <Redirect to={{ pathname: '/dash' }} />
    if (!location.state || !location.state.email) return <Redirect to={{ pathname: '/cadastro' }} />

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-header">
                    <img src={theme === 'dark' ? "/assets/images/logo/logobranca.svg" : "/assets/images/logo/logo.svg"} alt="Ambientar Logo" className="login-logo" />
                    <p className='subtit'>GERENCIADOR DE LICENÇAS E CONDICIONANTES</p>
                </div>

                <div className="login-card">
                    <div className="login-form-wrapper">
                        <Form onSubmit={onFinishCadastro} className="auth-form">
                            <div className='cadastro--header'>
                                <h1 className="cadastro-title">Verificação</h1>
                                <p className="cadastro-subtitle">Enviamos um código para <strong>{location.state.email}</strong>. Por favor, digite-o abaixo.</p>
                            </div>

                            <Input name='codigo' type='number' titulo='Código de Verificação' placeholder='000000' />

                            <div className="submit-container">
                                <Button load={load} name='Finalizar Cadastro' icon={<i className="fas fa-check-circle"></i>} />
                                {validacao && <div className="validaRetorno">{validacao}</div>}

                                <div style={{ marginTop: 10 }}>
                                    <Button
                                        type="button"
                                        onClick={reenviarCodigo}
                                        load={loadResend}
                                        disabled={timer > 0 || loadResend}
                                        name={timer > 0 ? `Aguarde ${timer}s` : 'Reenviar Código'}
                                        className='btn-ghost'
                                        icon={timer > 0 ? <i className="fas fa-clock"></i> : <i className="fas fa-redo"></i>}
                                    />
                                </div>
                            </div>

                            <ReCAPTCHA
                                ref={recaptchaRef}
                                size='invisible'
                                sitekey="6LeEskMeAAAAAKx_X9fXZ8pJSQ2F4T4pkR5x91m9"
                                onChange={() => { }}
                            />
                        </Form>
                    </div>
                </div>

                <div className="login-footer">
                    <p><Link to='/'>Voltar para o Login</Link></p>
                </div>
            </div>
        </div>
    )
}

export default CadastroCodigo